__turbopack_context__.v({
  "body": "_9DWlbG_body",
  "cancel-btn": "_9DWlbG_cancel-btn",
  "description": "_9DWlbG_description",
  "header": "_9DWlbG_header",
  "home-icon": "_9DWlbG_home-icon",
  "instruction-step": "_9DWlbG_instruction-step",
  "instructions": "_9DWlbG_instructions",
  "is-hidden": "_9DWlbG_is-hidden",
  "is-modern": "_9DWlbG_is-modern",
  "is-safari": "_9DWlbG_is-safari",
  "is-visible": "_9DWlbG_is-visible",
  "overlay": "_9DWlbG_overlay",
  "paragraph": "_9DWlbG_paragraph",
  "paragraph--bold": "_9DWlbG_paragraph--bold",
  "prompt": "_9DWlbG_prompt",
  "share-icon": "_9DWlbG_share-icon",
  "title": "_9DWlbG_title",
});
